import React, { useEffect, useState } from "react";
import logo from "../image/homeImage.jfif";
import { useNavigate } from "react-router-dom";
import { FaHome } from "react-icons/fa";
import { db } from "../firebase/fireabase";
import { doc, getDoc } from "firebase/firestore";
import { Link } from "react-router-dom";
import { GiBubbles } from "react-icons/gi";
import { CgMenuGridO } from "react-icons/cg";
import { HiLogin } from "react-icons/hi";
import { GiSpiderMask } from "react-icons/gi";
import { FaPhone } from "react-icons/fa";

const Header = () => {
  const navigate = useNavigate();
  const user = JSON.parse(localStorage.getItem("user"));

  const [userDoc, setUserDoc] = useState({});
  useEffect(() => {
    const fetchUserData = async () => {
      if (user) {
        const userDoc = await getDoc(doc(db, "users", user.uid));
        setUserDoc(userDoc.data());
      }
    };

    fetchUserData();
  }, []);

  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        alignItems: "center",
        justifyContent: "space-between",
        padding: "10px",
        boxShadow: "0px 0px 10px 0px rgba(0,0,0,0.75)",
      }}
    >
      <div
        onClick={() => {
          navigate("/");
        }}
        style={{
          cursor: "pointer",
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
        }}
      >
        <GiSpiderMask
          className="ml-2"
          style={{ color: "#f0ad4e !important" }}
        />
        <p>مخبرش</p>
      </div>

      <div
        style={{
          display: "flex",
          flexDirection: "row",
          alignItems: "center",
          justifyContent: "start",
          gap: "10px",
          cursor: "pointer",
        }}
      >
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "start",
            gap: "10px",
            cursor: "pointer",
          }}
        >
          <p
            style={{
              borderBottom: "1px solid #fff",
              color: "#fff",
              cursor: "pointer",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "5px",
            }}
            onClick={() => {
              navigate("/login");
            }}
          >
            <span className="hidden sm:block">تسجيل الدخول</span>
            <HiLogin /> |{" "}
          </p>
          <p
            onClick={() => {
              navigate("/signup");
            }}
            className="flex flex-row items-center gap-1"
          >
            <span className="hidden sm:block">إنشاء حساب</span>
            <GiSpiderMask /> |{" "}
          </p>
        </div>
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "start",
            gap: "10px",
          }}
        >
          <p
            style={{
              borderBottom: "1px solid #fff",
              color: "#fff",
              cursor: "pointer",
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              gap: "5px",
            }}
            onClick={() => {
              navigate("/allusers");
            }}
          >
            <Link to="/allusers" className="hidden sm:block">
              المستخدمين
            </Link>
            <GiBubbles /> |{" "}
          </p>
          <p
            onClick={() => {
              navigate("/allusersSearch");
            }}
          >
            <CgMenuGridO />
          </p>
        </div>
        <p
          style={{
            color: "#fff",
            cursor: "pointer",
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            gap: "8px",
          }}
          onClick={() => {
            navigate("/contactUsPage");
          }}
        >
          <span className="hidden sm:block">إتصل بنا</span>
          <FaPhone />
        </p>
        |
        <div
          className="flex flex-row items-center gap-1"
          onClick={() => {
            if (user !== null) {
              navigate("/myprofile/" + user.uid);
            } else {
              navigate("/login");
            }
          }}
        >
          <p className="hidden sm:block">ملفي الشخصي</p>
          <img
            src={user && userDoc.photoURL ? userDoc.photoURL : logo}
            alt=""
            width="50px"
            height="50px"
            style={{ borderRadius: "50%" }}
          />
        </div>
      </div>
    </div>
  );
};

export default Header;
